module.exports = __webpack_public_path__ + "img/welcomes-preview-current-empty-2.5c4c5804.png";